import { CookieValueTypes, getCookie, hasCookie } from "cookies-next";
import { useRouter } from "next/router";

const useLocation: () => {
  country: string | string[] | CookieValueTypes;
  city: string | string[];
} = () => {
  const router = useRouter();

  const country =
    "country" in router.query
      ? router.query.country
      : hasCookie("geoLocation")
      ? getCookie("geoLocation")
      : "us";
  const city = "city" in router.query ? router.query.city : undefined;
  return { city, country };
};

export default useLocation;
